module.exports = __webpack_public_path__ + "static/media/FangDiChan2.ca8f1f9d.png";